import { useEffect, useRef } from "react";

// Calls `fn` now and every `ms` while the tab is visible; refreshes immediately when the tab returns.
export default function usePolling(fn, ms) {
  const fnRef = useRef(fn);
  fnRef.current = fn;
  useEffect(() => {
    let busy = false;
    const tick = async () => {
      if (busy || document.hidden) return;
      busy = true;
      try { await fnRef.current(); } finally { busy = false; }
    };
    tick();
    const id = setInterval(tick, ms);
    const onVisible = () => { if (!document.hidden) tick(); };
    document.addEventListener("visibilitychange", onVisible);
    return () => { clearInterval(id); document.removeEventListener("visibilitychange", onVisible); };
  }, [ms]);
}

// Keeps the previous object when the server returns identical data, so nothing re-renders.
export const keepIfSame = (next) => (prev) => (prev && JSON.stringify(prev) === JSON.stringify(next) ? prev : next);
